export default {"src":"/_next/static/media/Copy.4e8e844e.svg","height":18,"width":16,"blurWidth":0,"blurHeight":0};